import React from 'react'
import { StaticImage } from 'gatsby-plugin-image';
import Slider from 'react-slick';
import parser from 'html-react-parser'

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

export default function Slider4({ data }) {
    const { slider4Slides } = data;

    const settings = {
        dots: false,
        infinite: true,
        arrow: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    return (
        <div className='dana-testimonial-sec'>
            <div className='container'>
                <div className='dana-testimonial-green-sec'>
                    <div className='row g-testimonial-slide-row slick-slider-arrow lt-rt-arrow'>
                        <div className='col-md-3'>
                            <figure className='dana-testi-icon'>
                                <StaticImage src='../../../images/head-icon.png' alt='image' />
                            </figure>
                        </div>
                        <div className='col-md-8'>
                            <Slider {...settings}>
                                {slider4Slides.map((block, i) => (
                                    <div key={i}>
                                        <div className='dana-testi-text'>
                                            <p>{block.slider4SlideText && parser(block.slider4SlideText)}</p>
                                        </div>
                                        <p className='text-uppercase'>
                                            {block.slider4SlideTitle && parser(block.slider4SlideTitle)}
                                        </p>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
